import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBodyBarcode } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { MaterialMaster } from '../../TitleList';
import { fetchMatInwardData } from '../../../Store/PHPSlice/MatInward';



const MatInwBarcodeReg = () => {
    const dispatch = useDispatch();
    const materials = useSelector((state) => state.MatInwardData.matInward || { data: [] });
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchMatInwardData());
    }, [dispatch]);

    if (!materials) {
        return <h1>Loading...</h1>;
    }

    // console.log(materials.data)
    const compData = Array.isArray(materials.data2) ? materials.data2?.map((item, index) => (
        {
            srno: item.ID,
            dt: item.dt,
            inwardNo: item.inwardNo,
            piNo: item.piNo,
            inwardType: item.inwardType,
            locationNm: item.locationNm,
            firmNm: item.firmNm,
            poId: item.poId,
            matId: item.matId,
            materialNm: item.materialNm,
            mqty: item.mqty,
            mtype: item.mtype,
            perpktqty: item.perpktqty,
            ptype: item.ptype,
            inwpqty: item.inwpqty,
            totmtr: item.totmtr,
            totinch: item.totinch,
            totqty: item.totqty,
            barcode: item.barcode,
            sts: item.sts,
            outsts: item.outsts,
            serialNumber: index + 1
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = [...Array(npages + 1).keys()].slice(1);
    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);


    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });
    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item => {
        const search = searchTerm.toLowerCase();

        return (
            item.inwardNo?.toLowerCase().includes(search) ||
            item.piNo?.toLowerCase().includes(search) ||
            item.firmNm?.toLowerCase().includes(search) ||
            item.locationNm?.toLowerCase().includes(search) ||
            item.materialNm?.toLowerCase().includes(search) ||
            item.mqty?.toLowerCase().includes(search) ||
            item.mtype?.toLowerCase().includes(search) ||
            item.perpktqty?.toLowerCase().includes(search) ||
            item.totqty?.toLowerCase().includes(search) ||
            item.totmtr?.toLowerCase().includes(search) ||
            item.totinch?.toLowerCase().includes(search) ||
            item.barcode?.toLowerCase().includes(search) ||
            item.inwpqty?.toLowerCase().includes(search) ||
            item.inwardType?.toLowerCase().includes(search)
        );
    });



    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={MaterialMaster} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Inward Register(Barcode)</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />

                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'locationNm', label: 'Location' },
                                                { id: 'inwardType', label: 'Inward Type' },
                                                { id: 'inwardNo', label: 'Inward No' },
                                                { id: 'piNo', label: 'Purchase Inward No.' },
                                                { id: 'barcode', label: 'Barcode' },
                                                { id: 'materialNm', label: 'Material' },
                                                { id: 'mqty', label: 'M. Qty' },
                                                { id: 'perpktqty', label: 'P.P Qty' },
                                                { id: 'inwpqty', label: 'Inward P.P Qty' },
                                                { id: 'totmtr', label: 'Mtr' },
                                                { id: 'totinch', label: 'Inch' },
                                                { id: 'totqty', label: 'Total Qty' },
                                                // { id: '', label: 'Edit' },
                                                // { id: '', label: 'Delete' }
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBodyBarcode
                                                key={row.srno}
                                                id={row.srno}
                                                inwardType={row.inwardType}
                                                inwardNo={row.inwardNo}
                                                firmNm={row.firmNm}
                                                locationNm={row.locationNm}
                                                poId={row.poId}
                                                matId={row.matId}
                                                materialNm={row.materialNm}
                                                mqty={row.mqty}
                                                mtype={row.mtype}
                                                perpktqty={row.perpktqty}
                                                ptype={row.ptype}
                                                inwpqty={row.inwpqty}
                                                totmtr={row.totmtr}
                                                totinch={row.totinch}
                                                totqty={row.totqty}
                                                barcode={row.barcode}
                                                dt={row.dt}
                                                piNo={row.piNo}
                                                sts={row.sts}
                                                outsts={row.outsts}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default MatInwBarcodeReg;
